import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';
import StationHeader from '../components/StationHeader';
import goTrackerConfig from 'goTrackerConfig';
import HeaderColumns from '../components/HeaderColumns';
import * as CONSTS from '../utils/constants';
import '../i18n';
import DirectionDepartures from './DirectionDepartures';
import TripDirectionHeader from '../components/TripDirectionHeader';

const StationDeparture = observer(props => {
  const { t } = useTranslation();

  const headerCol = [
    t('stationDepartures.columnHeadings.1'),
    t('stationDepartures.columnHeadings.2'),
    t('stationDepartures.columnHeadings.3'),
    t('stationDepartures.columnHeadings.4'),
    t('stationDepartures.columnHeadings.5'),
  ];
  const filteredCol = !goTrackerConfig.railOccupancy ? headerCol.filter(c => c !== t('stationDepartures.columnHeadings.3')) : headerCol;
  const headerClassName = `departure-header-row ${!goTrackerConfig.railOccupancy ? 'no-occupancy' : ''}`;

  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);

  const loadPage = () => {
    if (!props.station || !props.corridor) return;

    locationStore.setCorridor(props.corridor);
    locationStore.setStation(props.station);
    locationStore.loadTripsByCorridorAndStation();
  };

  useEffect(() => {
    loadPage();

    const interval = setInterval(() => {
      locationStore.loadTripsByCorridorAndStation();

      if (goTrackerConfig.debug) {
        viewStore.updateAutoRefreshTime();
      }
    }, goTrackerConfig.autoRefreshRate || 10000);
    return () => clearInterval(interval);
  }, [locationStore.corridors]);

  useEffect(() => {
    viewStore.updateView(CONSTS.VIEW_PATHS.STATION_DEPARTURE);
  }, []);

  return (
    <main id="main-content">
      <div className="selection">
        <StationHeader isTrain={true}/>
        <TripDirectionHeader />
        {locationStore.messages && locationStore.messages.directions.length > 0 ? (
          <DirectionDepartures corridor={props.corridor} station={props.station} />
        ) : (
          <React.Fragment>
            <HeaderColumns className={headerClassName} headerCol={filteredCol} />
            <div className="departure-row no-trip">
              <i className="fa fa-spinner fa-spin" />
            </div>
          </React.Fragment>
        )}
      </div>
    </main >
  );
});

export default StationDeparture;
